import React, { ReactNode } from "react";
import { styled } from "styled-components";

const ButtonBox = styled.button`
    width: 100px;
    height: 32px;
    border: none;
    outline: none;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(90deg, var(--btn-bg-color), var(--accent-color));
    color: white;
    font-size: 0.8rem;
    border-radius: 6px;
    padding: 0 12px;
`;

interface ButtonProps {
    onClick: any,
    icon?: any,
    children: ReactNode
}
const Button = ({onClick, icon=null, children}: ButtonProps) => {
    return (
        <ButtonBox onClick={onClick}>
            {children}
            {icon}
        </ButtonBox>
    );
}

export default Button;